import * as ExcelJS from 'exceljs';
import { ref } from '@vue/composition-api';
export const useExcelExport = (props) => {
    const saveProgress = ref({
        parsed: 0,
        total: 1,
        percent: 0,
    });
    const isExporting = ref(false);
    const setProgress = ({ parsed, total }) => {
        const percent = total > 0 ? Math.floor((parsed / total) * 100) : 0;
        saveProgress.value = { parsed, total, percent };
    };
    const createWorkbook = () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('My Sheet');
        sheet.columns = props.columns;
        return { workbook, sheet };
    };
    const saveWorkbook = async (workbook) => {
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${props.fileNamePrefix || 'objekto-export'}-${Date.now()}.xlsx`;
        document.body.append(a);
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
    };
    const addExcelRows = (sheet, nodes) => {
        for (const node of nodes) {
            sheet.addRow(props.dataMapper ? props.dataMapper(node) : node);
        }
    };
    const handleExport = async (dataGetter) => {
        if (isExporting.value)
            return;
        isExporting.value = true;
        try {
            const { workbook, sheet } = createWorkbook();
            const perPage = props.dataGetPageSize || '500';
            const { nodes, totalCount } = await dataGetter({ page: '1', perPage });
            addExcelRows(sheet, nodes);
            const pagesCount = Math.ceil(totalCount / Number(perPage));
            let parsed = nodes.length;
            setProgress({ parsed, total: totalCount });
            for (let page = 2; page <= pagesCount; page++) {
                const { nodes: pageNodes } = await dataGetter({
                    perPage: String(perPage),
                    page: String(page),
                });
                addExcelRows(sheet, pageNodes);
                parsed += pageNodes.length;
                setProgress({ parsed, total: totalCount });
            }
            await saveWorkbook(workbook);
        }
        finally {
            setProgress({ total: 1, parsed: 0 });
            isExporting.value = false;
        }
    };
    return {
        handleExport,
        saveProgress,
        isExporting,
    };
};
